import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card } from '../../components/ui/card';
import { Session } from '../../types/api';

interface ClientSessionHistoryItemProps {
  session: Session;
}

export function ClientSessionHistoryItem({ session }: ClientSessionHistoryItemProps) {
  return (
    <Card className="p-4 flex justify-between items-center">
      <div>
        <p className="font-semibold">{new Date(session.startTime).toLocaleDateString()}</p>
        <p className="text-sm text-muted-foreground">{session.exercises.length} exercises performed</p>
      </div>
      <Link to={`/studio/sessions/${session.sessionGuid}`}>
        <Button variant="outline" size="sm">View Details</Button>
      </Link>
    </Card>
  );
}